@if (config) {
  <div class="config-vecino">
    <div class="seccion">
      {{ config.cliente?.nombre || config.idCliente | titlecase }}
    </div>

    <div class="fila">
      <mat-icon>place</mat-icon>
      <span class="etiqueta">Dirección</span>
      @if (config.direccion?.direccion) {
        <span
          class="valor copiable"
          [matTooltip]="config.direccion?.direccion + ' (click para copiar)'"
          (click)="copiar(config.direccion?.direccion || '')"
        >
          {{ config.direccion?.direccion }}
        </span>
      } @else {
        <span class="valor no-info">Sin dirección</span>
      }
    </div>

    <div class="fila">
      <mat-icon>notes</mat-icon>
      <span class="etiqueta">Detalle</span>
      @if (config.direccion?.complementoDireccion) {
        <span class="valor" [matTooltip]="config.direccion?.complementoDireccion!">
          {{ config.direccion?.complementoDireccion }}
        </span>
      } @else {
        <span class="valor no-info">Sin detalle</span>
      }
    </div>

    <div class="fila">
      <mat-icon>schedule</mat-icon>
      <span class="etiqueta">Último acceso</span>
      @if (config.ultimoAcceso) {
        <span
          class="valor"
          [matTooltip]="(config.ultimoAcceso | date: 'short')!"
        >
          {{ config.ultimoAcceso | date: "shortDate" }}
        </span>
      } @else {
        <span class="valor no-info">Nunca</span>
      }
    </div>

    <div class="fila">
      <mat-icon>sell</mat-icon>
      <span class="etiqueta">Categoría</span>
      @if (config.categoria?.categoria?.nombre) {
        <span class="valor">
          {{ config.categoria?.categoria?.nombre | titlecase }}
        </span>
      } @else {
        <span class="valor no-info">Sin categoría</span>
      }
    </div>

    <div class="fila">
      @if (config.appType === "android") {
        <mat-icon class="app-android">android</mat-icon>
        <span class="etiqueta">App</span>
        <span class="valor">
          Android{{ config.appVersion ? " · v" + config.appVersion : "" }}
        </span>
      } @else if (config.appType === "ios") {
        <mat-icon class="app-ios">phone_iphone</mat-icon>
        <span class="etiqueta">App</span>
        <span class="valor">
          iOS{{ config.appVersion ? " · v" + config.appVersion : "" }}
        </span>
      } @else if (config.appType === "web") {
        <mat-icon class="app-web">public</mat-icon>
        <span class="etiqueta">App</span>
        <span class="valor">
          Web{{ config.appVersion ? " · v" + config.appVersion : "" }}
        </span>
      } @else if (config.appType === "rf") {
        <mat-icon class="app-rf">radio</mat-icon>
        <span class="etiqueta">App</span>
        <span class="valor">Control RF</span>
      } @else {
        <mat-icon>smartphone</mat-icon>
        <span class="etiqueta">App</span>
        <span class="valor no-info">Sin app</span>
      }
    </div>

    <div class="fila">
      <mat-icon>key</mat-icon>
      <span class="etiqueta">Código</span>
      @if (config.envioCodigo?.codigo) {
        <span class="valor swiper-no-swiping">
          {{ config.envioCodigo?.codigo }}
        </span>
      } @else {
        <span class="valor no-info">Sin código</span>
      }
    </div>
  </div>
}
